import { useCrimeSceneStore } from "src/store/crimeSceneStore";
import Text from "@/components/text/text";
import Image from "@/components/image";
export default function SimTimer() {
  const sceneTime = useCrimeSceneStore((state) => state.sceneTime);

  return (
    <div className="flex z-[50] bg-overlay rounded-3xl gap-2 p-[12px]">
      <Image src="/assets/icon_clock.svg" alt="Clock icon" />
      <Text text={sceneTime} translate={false} />
    </div>
  );
}
